import userAPI from 'apis/UserAPI';

export function resetPassword(data){
  return userAPI.resetPassword(data);
};